module.exports = __webpack_public_path__ + "static/media/image_12.53bd2d39.png";